import { render, staticRenderFns } from "./GetCustomers.vue?vue&type=template&id=5907b34e&"
import script from "./GetCustomers.vue?vue&type=script&lang=js&"
export * from "./GetCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports